import React from 'react';
import { observer } from 'mobx-react-lite';

import { fightersList } from '../../enums/uiConfig';

export const FightersCashOutHeader = observer(({ t, betData }) => {
  return (
    <div className='bet-fighter-head-row type-2'>
      <div className='cash-out-row-inner'>
        {betData.map((item) => (
          //  ADD CLASS " orange-type, green-type, pink-type, disabled, state-try-again "
          <div
            className={`cash-tabs ${item.betId ? fightersList[item.fighterNumber].jetColor : ''} ${
              item.betId && item.finishedOdd && !item.winAmount && !item.halfWinAmount
                ? 'state-try-again'
                : ''
            } ${!item.betId ? 'disabled' : ''}`}
            // style={{ display: isMobile() && !item.betId ? 'none' : '' }}
            key={item.fighterNumber}
          >
            <div className='tabs-line' />
            <span className='fighter-top-btn-text'>
              {t(fightersList[item.fighterNumber].jetName)}
            </span>
            <span className='fighters-x-icon' />
          </div>
        ))}
      </div>
    </div>
  );
});
